window.addEventListener('DOMContentLoaded', function() {
  const images = document.querySelectorAll('.blur-lazy .product__media img[loading=lazy]');
  for (const image of images) {
    if (!image.complete) {
      image.parentElement.classList.add('blur-lazy-image');
      image.addEventListener('load', () => {
        image.parentElement.classList.remove('blur-lazy-image');
      });
    }
  }
});

document.addEventListener('related-products:change', function() {
  const originalPriceContainer = document.querySelector('[data-original');
  let price = 0;

  if (originalPriceContainer) {
    price = parseFloat(originalPriceContainer.getAttribute('data-original'));
  }

  const relatedProductsContainers = document.querySelectorAll('linked-checkbox');

  for (const relatedProductContainer of relatedProductsContainers) {
    const checkbox = relatedProductContainer.querySelector('input[type=checkbox]');

    if (checkbox && checkbox.checked) {
      const relatedProductPrice = relatedProductContainer.querySelector('[data-price]');
      
      if (relatedProductPrice) {
        price += parseFloat(relatedProductPrice.getAttribute('data-price'));
      }
    }
  }

  if (originalPriceContainer) {
    originalPriceContainer.querySelector('.money').innerHTML = Shopify.formatMoney(price, window.themeVariables.moneyFormat);
  }
});